var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from "mobx";
import { isIH } from "@common/utils/userProfile";
var ReviewStore = /** @class */ (function () {
    function ReviewStore() {
        this.showDisclaimer = isIH() ? true : false;
        this.targetDisclaimer = false;
    }
    ReviewStore.prototype.setDisclaimerData = function (value) {
        this.showDisclaimer = value;
    };
    ReviewStore.prototype.setTargetDisclaimer = function (value) {
        this.targetDisclaimer = value;
    };
    ReviewStore.prototype.clear = function () {
        this.showDisclaimer = isIH() ? true : false;
        this.targetDisclaimer = false;
    };
    __decorate([
        observable
    ], ReviewStore.prototype, "showDisclaimer", void 0);
    __decorate([
        observable
    ], ReviewStore.prototype, "targetDisclaimer", void 0);
    __decorate([
        action.bound
    ], ReviewStore.prototype, "setDisclaimerData", null);
    __decorate([
        action.bound
    ], ReviewStore.prototype, "setTargetDisclaimer", null);
    __decorate([
        action.bound
    ], ReviewStore.prototype, "clear", null);
    return ReviewStore;
}());
export default ReviewStore;
